import React from "react";
import "../Servicesmain/Serve.css";

const Serve = () => {
  return (
    <div className="serve-container">
      <h1>
        Setting the Standard in <span>Landscape Excellence</span>
      </h1>
      <p className="description">
        At [Nursery Name], we specialize in delivering premium landscaping and grounds care services tailored to both residential and commercial spaces. With a legacy of innovation and commitment, our expert team ensures every project exceeds expectations—transforming outdoor spaces into works of art.
      </p>
      <div className="services-grid">
        <div className="service-category">
          <h3>Landscape Design</h3>
          <ul>
            <li>Bespoke Garden Layouts</li>
            <li>Soil & Plant Selection</li>
            <li>Irrigation Planning</li>
            <li>Environmentally Conscious Solutions</li>
          </ul>
        </div>
        <div className="service-category">
          <h3>Installation</h3>
          <ul>
            <li>Advanced Irrigation Systems</li>
            <li>Water Features & Ponds</li>
            <li>Hardscape Implementation</li>
            <li>Comprehensive Weed Prevention</li>
          </ul>
        </div>
        <div className="service-category">
          <h3>Maintenance</h3>
          <ul>
            <li>Ongoing Lawn & Garden Care</li>
            <li>Outdoor Lighting Solutions</li>
            <li>Structural Enhancements</li>
            <li>Seasonal Property Refresh</li>
          </ul>
        </div>
        <div className="service-category">
          <h3>Premium Supplies</h3>
          <ul>
            <li>Top-tier Gardening Equipment</li>
            <li>Custom Planters & Decor</li>
            <li>Landscape Design Resources</li>
            <li>Eco-friendly Fertilizers</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Serve;
